import Polyline from '@mui/icons-material/Polyline'
import { styled } from '@mui/material/styles'
import React from 'react'

import Tooltip from '@/app/component/atom/tooltip'

type Props = {
  hasModifiers?: boolean
  label: string
  onInspect?: (trigger: HTMLElement) => void
}

// Displays a personalization label with optional mouse and keyboard activation to inspect its details.
const PzPill: React.FC<Props> = ({ hasModifiers = false, label, onInspect }) => {
  const tooltip = hasModifiers ? 'View details (has modifiers)' : 'View details'

  return (
    <Tooltip title={onInspect ? tooltip : ''}>
      <Container
        aria-haspopup={onInspect ? 'dialog' : undefined}
        aria-label={onInspect ? `View details for ${label}` : undefined}
        role={onInspect ? 'button' : undefined}
        tabIndex={onInspect ? 0 : undefined}
        onClick={
          onInspect
            ? (event) => {
                event.stopPropagation()
                onInspect(event.currentTarget)
              }
            : undefined
        }
        onKeyDown={
          onInspect
            ? (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault()
                  event.stopPropagation()
                  onInspect(event.currentTarget)
                }
              }
            : undefined
        }
        onMouseDown={onInspect ? (event) => event.preventDefault() : undefined}
      >
        <HiddenSpan>{'{{'}</HiddenSpan>
        {label}
        {hasModifiers && <ModifierIcon aria-label="Has modifiers" />}
        <HiddenSpan>{'}}'}</HiddenSpan>
      </Container>
    </Tooltip>
  )
}

const Container = styled('span')({
  position: 'relative',
  zIndex: 9999,
  color: 'white',
  backgroundColor: '#4E98BB',
  borderRadius: '3px',
  padding: '2px 0px',
  '&[role=button]': {
    cursor: 'pointer',
    textDecoration: 'underline dotted',
    textUnderlineOffset: '2px',
    transition: 'background-color 120ms',
    '&:hover, &:focus-visible': {
      backgroundColor: '#2F80AC',
    },
    '&:active': { backgroundColor: '#205978' },
  },
  '&:focus-visible': { outline: 'none' },
})

const ModifierIcon = styled(Polyline)({
  borderLeft: '1px solid rgba(255, 255, 255, 0.6)',
  boxSizing: 'content-box',
  fontSize: '1em',
  marginLeft: '4px',
  paddingLeft: '4px',
  verticalAlign: 'middle',
})

const HiddenSpan = styled('span')({ visibility: 'hidden' })

export default React.memo(PzPill)
